import { lazy, Suspense, type ReactNode } from 'react'
import { env } from '@/config/env'
import { FullPageState, LoadingState } from '@/components/feedback/LoadingState'
import { MockSessionProvider } from './MockSessionProvider'

// O provider OIDC só entra no bundle carregado quando o modo é oidc.
const OidcSessionProvider = lazy(() =>
  import('./OidcSessionProvider').then((module) => ({ default: module.OidcSessionProvider })),
)

export function AuthSessionProvider({ children }: { children: ReactNode }) {
  if (env.authMode === 'mock') return <MockSessionProvider>{children}</MockSessionProvider>
  return (
    <Suspense
      fallback={
        <FullPageState>
          <LoadingState label="Carregando autenticação…" />
        </FullPageState>
      }
    >
      <OidcSessionProvider>{children}</OidcSessionProvider>
    </Suspense>
  )
}
